import type { ReactNode } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

interface SiteLayoutProps {
  children: ReactNode;
  noTopPadding?: boolean;
}

export default function SiteLayout({ children, noTopPadding = false }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className={`flex-1 w-full ${noTopPadding ? '' : 'pt-16 md:pt-20'}`}>{children}</main>
      <SiteFooter />
    </div>
  );
}